import React from "react";
import Slider from "react-slick";
import vipin from "../../assets/testimonials/vipin.jpeg"
import akash from "../../assets/testimonials/akash.jpeg"
import dubai from "../../assets/testimonials/dubai.jpeg"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonialData = [
  {
    id: 1,
    name: "Vipin Vishwakarma",
    text: "Planning our family vacation with TripDekhoo was a fantastic experience! The platform was easy to navigate, and their suggestions for activities in Dubai were excellent. We had a great time exploring the city, and everything was so well-organized. Highly recommend TripDekhoo for family trips!",
    role: "Designer",
    profileImage: vipin,
  },
  {
    id: 2,
    name: "Rakesh Soni",
    text: "TripDekhoo made our Dubai trip so easy and enjoyable! They helped us plan everything perfectly, from visiting iconic landmarks to exploring hidden gems in the city. The team was incredibly supportive and ensured we had a hassle-free experience. It was a trip to remember!",
    role: "Traveler",
    profileImage: akash,
  },
  {
    id: 3,
    name: "Rahul Verma",
    text: "TripDekhoo organized our group trip to Dubai perfectly! The itineraries were well-planned, and we got to explore all the major attractions without any hassle. The desert safari and city tours were amazing. I highly recommend TripDekhoo for group travelers!",
    role: "Group Traveler",
    profileImage: dubai,
  }
];

const Testimonial = () => {
  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 4000,
    cssEase: "ease-in-out",
    arrows: false,
  };

  return (
    <div className="py-16 bg-gradient-to-r from-purple-800 to-indigo-900 text-white">
      <div className="text-center mb-10">
        <h2 className="text-4xl font-bold">What Our Customers Say</h2>
        <p className="mt-4 text-lg text-gray-300">
          Join over 1000+ happy customers who trust us!
        </p>
      </div>
      <div className="max-w-5xl mx-auto">
        <Slider {...settings}>
          {testimonialData.map(({ id, name, text, role, profileImage }) => (
            <div key={id} className="p-6">
              <div className="flex flex-col md:flex-row items-center bg-white rounded-xl shadow-lg overflow-hidden">
                {/* Profile Image */}
                <div className="flex-shrink-0">
                  <img
                    src={profileImage}
                    alt={name}
                    className="w-40 h-40 object-cover rounded-full mx-auto border-4 border-yellow-500 mt-4 md:mt-0"
                  />
                </div>
                {/* Testimonial Content */}
                <div className="flex-1 p-6">
                  <h3 className="text-2xl font-bold text-gray-800">{name}</h3>
                  <p className="text-yellow-500 text-sm font-medium mb-2">
                    {role}
                  </p>
                  <p className="text-gray-600 mt-4 text-lg">{text}</p>
                  {/* Stars */}
                  <div className="flex justify-center md:justify-start mt-4">
                    {[...Array(5)].map((_, index) => (
                      <svg
                        key={index}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        className="w-5 h-5 md:w-6 md:h-6 text-yellow-500"
                      >
                        <path d="M12 .587l3.668 7.431L24 9.75l-6 5.838 1.416 8.338L12 18.896 4.584 23.926 6 15.588 0 9.75l8.332-1.732L12 .587z" />
                      </svg>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Testimonial;
